import React from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { media } from "../constants/styles";
import Button from "../components/Button";
import { ReactComponent as LogoBars } from "../svgs/logo-bars.svg";
import { useNavigate } from "react-router-dom";

interface NotFoundProps { }

const NotFound: React.FC<NotFoundProps> = () => {
  const navigate = useNavigate()

  return (
    <>
      <Helmet>
        <title>404</title>
        <meta name="description" content="NotFound Page" />
      </Helmet>
      <MainContainer>
        <LeftLogo />
        <RightLogo />
        <LeftCircle />
        <RightCircle />

        <ContentWrapper>
          <TitleText>404</TitleText>
          <SubTitleText>PAGE NOT FOUND</SubTitleText>
          <Content>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            <br />
            Duis semper convallis euismod vestibulum in pharetra.
          </Content>
          <ButtonWrapper>
            <Button
              types="default"
              label="홈으로 돌아가기"
              onClick={() => navigate('/')}
              style={{ width: '100%', height: '100%', alignItems: 'center' }}
            />
          </ButtonWrapper>
        </ContentWrapper>

      </MainContainer>
    </>
  );
};

export default NotFound;

const MainContainer = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  background: #111111;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`
const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const TitleText = styled.h1`
  color: #ffffff;
  font-size: 280px;
  font-weight: 700;
  line-height: 280px;
  text-align: center;

  ${media.TABLET} {
  }
  ${media.MOBILE} {
    font-size: 145px;
  }
`
const SubTitleText = styled.h2`
  color: #ffffff;
  font-size: 64px;
  font-weight: 900;
  line-height: 64px;
  ${media.TABLET} {
  }
  ${media.MOBILE} {
    font-size: 34px;
  }
`
const Content = styled.p`
  margin-top: 44px;
  margin-bottom: 80px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  ${media.TABLET} {
  }
  ${media.MOBILE} {
    width: 327px;
    text-align: center;
    font-size: 20px;
  }
`
const ButtonWrapper = styled.div`
  height: 68px;
  width: 286px;
  ${media.MOBILE}{
    height: 48px;
    width: 100%;
  }
`
const LeftLogo = styled(LogoBars)`
  position: absolute;
  top: 10px;
  left: -50px;
  color: rgba(179, 255, 1, 0.2);
  width: 313px;
  height: 375px;
  ${media.TABLET} {
  }
  ${media.MOBILE} {
  }
`
const RightLogo = styled(LogoBars)`
  position: absolute;
  top: 10px;
  right: -50px;
  color: rgba(80 ,80, 80, 0.2);
  width: 313px;
  height: 375px;
  ${media.TABLET} {
  }
  ${media.MOBILE} {
  }
`
const LeftCircle = styled.div`
  position: absolute;
  bottom:15vh;
  left: 3vw;
  width: 304px;
  height: 304px;
  border-radius: 305px;
  border: 64px solid rgba(60, 60, 60,0.3);
  ${media.TABLET} {
  }
  ${media.MOBILE} {
  }
`
const RightCircle = styled.div`
  position: absolute;
  bottom:-150px;
  right: 3vw;
  width: 294px;
  height: 294px;
  border-radius: 305px;
  border: 40px solid rgba(179, 255, 1, 0.2);
  ${media.TABLET} {
  }
  ${media.MOBILE} {
  }
`
